var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_15487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.6436 97.4528H23.3538C19.335 97.4528 16.0771 94.1949 16.0771 90.1761V9.82745C16.0771 5.80862 19.335 2.55078 23.3538 2.55078H76.6436C80.6624 2.55078 83.9203 5.80862 83.9203 9.82745V90.1761C83.9203 94.1949 80.6624 97.4528 76.6436 97.4528Z",
    fill: "url(#paint0_linear_331_15487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3447 38.6587C69.3943 35.3521 70.5249 31.416 70.379 27.207C70.0045 16.3958 61.1064 7.69148 50.2898 7.54109C38.8945 7.38246 29.6072 16.5723 29.6072 27.9313C29.6072 31.8452 30.71 35.5015 32.6217 38.6066C34.7857 42.1211 34.2611 46.6272 31.4382 49.6381C27.181 54.1791 24.571 60.2827 24.5625 66.9966C24.5449 81.0495 35.9466 92.4662 49.9996 92.466C64.0478 92.4658 75.436 81.0774 75.436 67.0291C75.436 60.3019 72.8241 54.1854 68.5594 49.637C65.7527 46.6436 65.1827 42.1466 67.3447 38.6587Z",
    fill: "url(#paint1_linear_331_15487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6449 2.55078H50V27.9306H83.9216V9.82745C83.9216 5.80862 80.6637 2.55078 76.6449 2.55078Z",
    fill: "url(#paint2_linear_331_15487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3538 2.55078H49.9987V27.9306H16.0771V9.82745C16.0771 5.80862 19.335 2.55078 23.3538 2.55078Z",
    fill: "url(#paint3_linear_331_15487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9199 90.1763V77.1818L61.8825 55.1445L38.1143 78.9128L56.6545 97.453H76.6433C80.6621 97.453 83.9199 94.1951 83.9199 90.1763Z",
    fill: "url(#paint4_linear_331_15487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0771 73.2852V90.1744C16.0771 94.1932 19.335 97.451 23.3538 97.451H76.6436C80.6624 97.451 83.9203 94.1932 83.9203 90.1744V73.2852H16.0771Z",
    fill: "url(#paint5_linear_331_15487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.92 46.0608L57.8943 20.0352L42.1025 35.8271L83.92 77.6448V46.0608Z",
    fill: "url(#paint6_linear_331_15487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9217 60.4883H78.3232V62.7148L83.9217 68.3132V60.4883Z",
    fill: "url(#paint7_linear_331_15487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9981 83.8321C59.2801 83.8321 66.8047 76.3075 66.8047 67.0254C66.8047 57.7434 59.2801 50.2188 49.9981 50.2188C40.716 50.2188 33.1914 57.7434 33.1914 67.0254C33.1914 76.3075 40.716 83.8321 49.9981 83.8321Z",
    fill: "url(#paint8_linear_331_15487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6677 62.4219L45.332 71.7576L68.3799 94.8052C71.6905 91.7205 74.2236 87.8132 75.6542 83.4082L54.6677 62.4219Z",
    fill: "url(#paint9_linear_331_15487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9998 73.691C53.6456 73.691 56.6012 70.7355 56.6012 67.0897C56.6012 63.4438 53.6456 60.4883 49.9998 60.4883C46.354 60.4883 43.3984 63.4438 43.3984 67.0897C43.3984 70.7355 46.354 73.691 49.9998 73.691Z",
    fill: "url(#paint10_linear_331_15487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9997 39.1029C56.1669 39.1029 61.1663 34.1034 61.1663 27.9362C61.1663 21.769 56.1669 16.7695 49.9997 16.7695C43.8325 16.7695 38.833 21.769 38.833 27.9362C38.833 34.1034 43.8325 39.1029 49.9997 39.1029Z",
    fill: "url(#paint11_linear_331_15487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9513 96.6581L19.3283 36.0352H16.0771V90.1773C16.0771 94.1961 19.335 97.454 23.3538 97.454H76.6436C77.835 97.454 78.9585 97.1657 79.9513 96.6581Z",
    fill: "url(#paint12_linear_331_15487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5218 49.6996L17.3814 42.1037C16.7951 41.6166 16.7545 40.7311 17.2933 40.1921L19.2341 38.2513C20.1567 37.3288 19.6827 35.7503 18.4045 35.4886L3.58863 32.4539C0.553338 31.8321 -1.29549 35.6819 1.08746 37.6623L10.2278 45.258C10.8141 45.745 10.8547 46.6307 10.3159 47.1696L8.3751 49.1101C7.45255 50.0327 7.92648 51.6111 9.20471 51.8731L24.0206 54.9076C27.0561 55.5296 28.9047 51.6798 26.5218 49.6996Z",
    fill: "url(#paint13_linear_331_15487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5269 59.1806L85.9271 53.031C86.4016 52.6366 86.4347 51.9198 85.9982 51.4833L84.4271 49.9121C83.68 49.1651 84.0637 47.8872 85.0986 47.6753L97.0939 45.2184C99.5514 44.7151 101.048 47.8319 99.1188 49.4353L91.7186 55.5849C91.2441 55.9792 91.211 56.6963 91.6475 57.1325L93.2186 58.7037C93.9657 59.4508 93.582 60.7286 92.5471 60.9406L80.5518 63.3974C78.0945 63.9008 76.5977 60.7839 78.5269 59.1806Z",
    fill: "url(#paint14_linear_331_15487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.343 1.70196V2.5902C28.343 3.5302 27.5811 4.29216 26.6411 4.29216H26.0352C21.225 4.29216 17.3254 8.19157 17.3254 13.002V13.0039C17.3254 13.9439 16.5634 14.7059 15.6234 14.7059H15.2313C14.2913 14.7059 13.5293 13.9439 13.5293 13.0039V9.44706C13.5293 4.22961 17.7589 0 22.9764 0H26.6411C27.5811 0 28.343 0.761961 28.343 1.70196Z",
    fill: "url(#paint15_linear_331_15487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.47 9.44706V13.0039C86.47 13.9439 85.708 14.7059 84.768 14.7059H84.3759C83.4359 14.7059 82.6739 13.9439 82.6739 13.0039C82.6739 8.19255 78.7735 4.29216 73.9621 4.29216H73.3582C72.4182 4.29216 71.6562 3.5302 71.6562 2.5902V1.70196C71.6562 0.761961 72.4182 0 73.3582 0H77.0229C82.2404 0 86.47 4.22961 86.47 9.44706Z",
    fill: "url(#paint16_linear_331_15487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.47 86.9949V90.5518C86.47 95.7692 82.2404 99.9988 77.0229 99.9988H73.3582C72.4182 99.9988 71.6562 99.2369 71.6562 98.2969V97.4087C71.6562 96.4687 72.4182 95.7067 73.3582 95.7067H73.9641C78.7743 95.7067 82.6739 91.8073 82.6739 86.9969V86.9949C82.6739 86.0549 83.4359 85.293 84.3759 85.293H84.768C85.708 85.293 86.47 86.0549 86.47 86.9949Z",
    fill: "url(#paint17_linear_331_15487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.343 97.4087V98.2969C28.343 99.2369 27.5811 99.9988 26.6411 99.9988H22.9764C17.7589 99.9988 13.5293 95.7692 13.5293 90.5518V86.9949C13.5293 86.0549 14.2913 85.293 15.2313 85.293H15.6234C16.5634 85.293 17.3254 86.0549 17.3254 86.9949C17.3254 91.8063 21.2258 95.7067 26.0371 95.7067H26.6411C27.5811 95.7067 28.343 96.4687 28.343 97.4087Z",
    fill: "url(#paint18_linear_331_15487)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_331_15487",
    x1: 19.4105,
    y1: 19.4135,
    x2: 73.2734,
    y2: 73.2765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_331_15487",
    x1: 66.3335,
    y1: 67.3938,
    x2: 25.6525,
    y2: 26.7129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_331_15487",
    x1: 70.0214,
    y1: 12.18,
    x2: 81.2047,
    y2: 0.996664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_331_15487",
    x1: 29.9773,
    y1: 12.18,
    x2: 18.794,
    y2: 0.996665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_331_15487",
    x1: 70.6041,
    y1: 87.6341,
    x2: 41.1827,
    y2: 58.2128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_331_15487",
    x1: 49.9987,
    y1: 86.0785,
    x2: 49.9987,
    y2: 98.0538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_331_15487",
    x1: 78.6812,
    y1: 56.6138,
    x2: 37.727,
    y2: 15.6597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_331_15487",
    x1: 90.2776,
    y1: 70.7565,
    x2: 81.2903,
    y2: 61.7693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_331_15487",
    x1: 41.2887,
    y1: 58.316,
    x2: 54.533,
    y2: 71.5603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_331_15487",
    x1: 69.8887,
    y1: 86.9785,
    x2: 44.2114,
    y2: 61.3013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_331_15487",
    x1: 48.1729,
    y1: 65.2628,
    x2: 50.4898,
    y2: 67.5797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_331_15487",
    x1: 45.153,
    y1: 23.0893,
    x2: 54.2754,
    y2: 32.2119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_331_15487",
    x1: 33.2324,
    y1: 73.4995,
    x2: 1.66382,
    y2: 56.8328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_331_15487",
    x1: 18.1131,
    y1: 36.1409,
    x2: 7.85843,
    y2: 54.0866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_331_15487",
    x1: 85.3345,
    y1: 48.2035,
    x2: 93.6369,
    y2: 62.7325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_331_15487",
    x1: 16.8569,
    y1: 3.27373,
    x2: 21.3091,
    y2: 7.72588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_331_15487",
    x1: 77.52,
    y1: 2.87157,
    x2: 83.2776,
    y2: 8.62902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_331_15487",
    x1: 76.7372,
    y1: 90.32,
    x2: 82.4125,
    y2: 95.9953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_331_15487",
    x1: 15.5511,
    y1: 90.1992,
    x2: 21.0491,
    y2: 95.6973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_15487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.2c1d01e6b664f432c0eb2af46a2a9b92.svg";
export { ForwardRef as ReactComponent };